export default __webpack_public_path__ + "static/media/hexagon.90baddb1.svg";